import "./Home.module.css";
import PulseThreadEntry from "@/reusable_sections/Header";
import TheCreativeSpark from "./sections/TheCreativeSpark";
import ProtectionSolutions from "./sections/ProtectionSolutions";
import RecentTransformations from "./sections/RecentTransformations";
import ClientReflections from "./sections/ClientReflections";
import ServiceCoverageArea from "./sections/ServiceCoverageArea";
import ScheduleYourFreeInspection from "./sections/ScheduleYourFreeInspection";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <PulseThreadEntry />
      <TheCreativeSpark />
      <ProtectionSolutions />
      <RecentTransformations />
      <ClientReflections />
      <Testimonials />
      <ServiceCoverageArea />
      <ScheduleYourFreeInspection />
      <Footer />
    </div>;
}